// Time-window selector chip group. Default options span 7/30/90/all; pages
// can pass a custom set via the `options` prop.
export const DEFAULT_WINDOWS = [
  { value: 7, label: '7d' },
  { value: 30, label: '30d' },
  { value: 90, label: '90d' },
  { value: 3650, label: 'all' },
];

export function WindowChips({ value, onChange, options = DEFAULT_WINDOWS, label }) {
  return (
    <div className="flex gap-1 items-center">
      {label && <span className="text-xs text-stone-500 mr-1">{label}:</span>}
      {options.map((w) => (
        <button
          key={w.value}
          onClick={() => onChange(w.value)}
          className={`text-xs px-2 py-0.5 rounded ${
            value === w.value
              ? 'bg-stone-800 text-white'
              : 'bg-white text-stone-700 border'
          }`}
        >
          {w.label}
        </button>
      ))}
    </div>
  );
}

export function windowLabel(days, options = DEFAULT_WINDOWS) {
  return options.find((w) => w.value === days)?.label || `${days}d`;
}
